var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "077E0DCF-7C5A-4384-8F27-CA07293F6353") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.82694012,1.73236906 C7.7875516,0.049960315 10.2124484,0.049960315 11.1730599,1.73236906 L11.1730599,1.73236906 L16.9172338,11.7852358 C17.8703233,13.4536779 16.6656287,15.53 14.74425,15.53 L14.74425,15.53 L3.25575,15.53 C1.33356088,15.53 0.128735049,13.4534517 1.08280867,11.7851615 L1.08280867,11.7851615 Z M9.87044012,2.47613094 C9.4855516,1.80203969 8.5144484,1.80203969 8.12944133,2.47633851 L8.12944133,2.47633851 L2.38505374,12.5295792 C2.00275769,13.1980609 2.48545375,14.03 3.25575,14.03 L3.25575,14.03 L14.74425,14.03 C15.5138567,14.03 15.996684,13.1978348 15.6148087,12.5293385 L15.6148087,12.5293385 Z M8.99925,10.34375 L9.10861507,10.3500498 C9.5750425,10.4041422 9.9375,10.7999778 9.9375,11.28125 C9.9375,11.7989636 9.51771356,12.21875 9,12.21875 C8.48228644,12.21875 8.06249456,11.7989636 8.06251969,11.2866846 C8.05901758,10.8033938 8.42203166,10.4046025 8.88961029,10.3500981 L8.99925,10.34375 Z M9,5.285 C9.37969577,5.285 9.69349096,5.56715388 9.74315338,5.93322944 L9.75,6.035 L9.75,8.84 C9.75,9.25421356 9.41421356,9.59 9,9.59 C8.62030423,9.59 8.30650904,9.30784612 8.25684662,8.94177056 L8.25,8.84 L8.25,6.035 C8.25,5.62078644 8.58578644,5.285 9,5.285 Z",
    id: "error-path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "error-LOGIN-FLOW-v4",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-03.1-invalid-email-v2",
    transform: "translate(-16.000000, -351.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "error-Group",
    transform: "translate(16.000000, 351.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "error-Path",
    points: "0 0 18 0 18 18 0 18"
  }), /*#__PURE__*/React.createElement("g", {
    id: "error-colours/neutral/N100",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "error-mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#error-path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "error-Mask",
    fill: "#323232",
    fillRule: "nonzero",
    xlinkHref: "#error-path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#error-mask-2)",
    id: "error-colours/error/RE400"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-51.000000, -52.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "error-colours/secondary/R400",
    fill: "#DE350B",
    x: 0,
    y: 0,
    width: 120,
    height: 120
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.120e6fdf568685834c4b57962e2f7760.svg";
export { ForwardRef as ReactComponent };